import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { BlurWrapper, Loader, ContactAdvisor } from 'ui';

import { ScoreWidget, ScoreWidgetMainColumn, ScoreWidgetSingleValueColumn } from 'ui/ScoreWidget';

const useStyles = makeStyles(() => ({
  requestBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    paddingLeft: '25px',
    paddingRight: '25px',
    whiteSpace: 'break-spaces',
    textAlign: 'center',
  },
}));

const RequestRating = ({ onRequest }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Typography display="block" className={classes.whiteText}>
        {t(
          'The assessment is available after request. Depending on your license, the request might be subject to charge.',
        )}
      </Typography>
      <Box mt={1}>
        <Button variant="contained" size="small" color="primary" onClick={onRequest}>
          {t('Request')}
        </Button>
      </Box>
    </>
  );
};

RequestRating.propTypes = {
  onRequest: PropTypes.func.isRequired,
};

const BlurredContactAdvisorBox = ({ isPending, handleRatingRequest, contactAdvisor, active }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const content = handleRatingRequest ? (
    <RequestRating onRequest={handleRatingRequest} />
  ) : (
    <ContactAdvisor>{contactAdvisor}</ContactAdvisor>
  );

  return (
    <>
      <BlurWrapper
        content={
          active ? (
            <div className={classes.requestBox}>{isPending ? <Loader /> : content}</div>
          ) : null
        }
      >
        <ScoreWidget>
          <ScoreWidgetMainColumn
            label={t('Score')}
            value={t('Score')}
            footer={t(`1 year PD`)}
            footerColor="white"
          />
          <ScoreWidgetSingleValueColumn
            label={t('Country Risk Assessment')}
            value={t('Country Risk Assessment')}
          />
          <ScoreWidgetSingleValueColumn
            label={t('Business Climate')}
            value={t('Business Climate')}
          />
          <ScoreWidgetSingleValueColumn
            label={t('Industry Risk Level')}
            value={t('Industry Risk Level')}
          />
          <ScoreWidgetSingleValueColumn
            label={t('Credit review date')}
            value={t('Credit review date')}
            last
          />
        </ScoreWidget>
      </BlurWrapper>
    </>
  );
};

BlurredContactAdvisorBox.defaultProps = {
  isPending: false,
  handleRatingRequest: null,
  contactAdvisor: '',
  active: true,
};

BlurredContactAdvisorBox.propTypes = {
  isPending: PropTypes.bool,
  handleRatingRequest: PropTypes.func,
  contactAdvisor: PropTypes.node,
  active: PropTypes.bool,
};

export default BlurredContactAdvisorBox;
